import { Navigate } from 'react-router-dom'

import { BASKETS_ROUTE } from './baskets'

export const ORDERS_ROOT_ROUTE = '/orders'

export const OrdersRootPage: React.FC = () => <Navigate to={BASKETS_ROUTE} />
